<template>
  <div class="bet-amount-wrapper">
    <!-- Üst Başlık -->
    <div class="amount-header">
      <span class="amount-label"> {{ $t('wingo.Amount') }}</span>
      <span class="info-icon">ⓘ</span>
    </div>

    <!-- Miktar Girişi + Sembol + Kontroller -->
    <div class="amount-input">
      <img src="@/assets/img/chip-rivo.png" alt="currency" />

      <input
  type="number"
  v-model.number="internalAmount"
  min="0"
  placeholder="0"
  @input="emitChange"
  class="bold-input"
/>


      <div class="amount-controls">
        <button @click="halve">½</button>
        <button @click="double">2×</button>
        
      </div>
    </div>

    <!-- Hızlı Butonlar (sadece PC) -->
    <div class="quick-buttons">
      <button @click="setAmount(1)">1</button>
      <button @click="setAmount(10)">10</button>
      <button @click="setAmount(25)">25</button>
      <button @click="setAmount(50)">50</button>
      <button @click="setAmount(75)">75</button>
      <button @click="setAmount(100)">100</button>
      <button @click="setAmount(150)">150</button>
      <button @click="setAmount(200)">200</button>
      <button @click="setAmount(1000)">1k</button>
      <button @click="clear"> {{ $t('wingo.Clear') }}</button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: Number
})

const emit = defineEmits(['update:modelValue'])
const internalAmount = ref(props.modelValue || 0)

watch(() => props.modelValue, (val) => {
  internalAmount.value = val
})

const emitChange = () => {
  emit('update:modelValue', internalAmount.value)
}

const setAmount = (val) => {
  internalAmount.value = val
  emitChange()
}

const halve = () => {
  internalAmount.value = Math.floor(internalAmount.value / 2)
  emitChange()
}

const double = () => {
  internalAmount.value = internalAmount.value * 2
  emitChange()
}

const clear = () => {
  internalAmount.value = 0
  emitChange()
}
</script>

<style scoped>
/* Mevcut class (korundu) */
.bet-amount-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
 
}

/* Yeni başlık üstü */
.amount-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #fff;
  margin-bottom: 4px;
}

.amount-label {
  font-weight: 600;
}

.info-icon {
  font-size: 12px;
  color: #fff;
}

/* Mevcut input kapsayıcısı (sınıf korunuyor) */
.amount-input {
  display: flex;
  align-items: center;
  background: var(--background);
  border-radius: 5px;
  padding: 6px 10px;
  position: relative;
  gap: 8px;
  z-index: 1;
}
 
/* Sembol */
.amount-input img {
  width: 20px;
  height: 20px;
}

/* Mevcut input (sınıf korunuyor) */
.amount-input input {
  flex: 1;
  background: transparent;
  border: none;
  color: white;
  font-size: 15px;
  text-align: left;
  outline: none;
  padding: 0;
}

/* Yeni kontroller (½, 2x, ↑ ↓) */
.amount-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.amount-controls button {
    background: var(--buttonyellow);
    box-shadow: var(--buttonyellowbox);
    color: #fff;
        text-shadow: -1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), 1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), -1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18), 1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18);
  border: none;
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 13px;
  cursor: pointer;
  font-weight: bold;
  transition: 0.2s;
}

 

.arrow-button {
  padding: 2px 6px;
  font-size: 11px;
}

/* Mevcut hızlı butonlar (sınıf korunuyor) */
.quick-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
  justify-content: center;
}

.quick-buttons button {
    background: var(--buttonyellow);
    box-shadow: var(--buttonyellowbox);
    color: #fff;
        text-shadow: -1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), 1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), -1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18), 1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18);
  padding: 4px 8px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: bold;
  transition: 0.2s all;
}



.bold-input {
  font-weight: bold;
}
/* Quick buttons only on PC */
@media (max-width: 768px) {
  .quick-buttons {
    display: none;
  }
}
</style>
